module.exports = __webpack_public_path__ + "static/media/JW-marriot04.665bcc55.jpg";